import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import type { Location } from 'vue-router';
import AssetOverviewTransformation from '@/components/asset/overview/Asset-Overview-Transformation.vue';
import SAvatars from '@/components/SAvatars/SAvatars.vue';
import fromNow from '@/utils/filters/fromNow';
import { getProviderIconSrc } from '@/utils/provider-icons';
import type {
  TransformationAssetOverview,
} from '@/api';

interface AssetOverviewTransformationPanelProps {
  urn: string;
  overviewData: TransformationAssetOverview;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Asset-Overview-Transformation-Panel',
  props: {
  urn: null,
  overviewData: null
},
  setup(__props) {

const props = __props;


const routeToOverview = _computed<Location>(() => ({
  name: 'data-catalog.asset.overview',
  params: { urn: props.urn },
}));

const details = _computed(() => props.overviewData?.details);

const descriptionValue = _computed(() => details.value?.description ?? '-');
const datasourceName = _computed(() => (details.value?.datasourceName ?? ''));
const ownersValue = _computed(() => details.value?.owners ?? []);
const lastRefresh = _computed(() => fromNow((details.value?.lastRefresh || '') as string));
const lineagePlatform = _computed(() => (details.value?.lineagePlatform ?? ''));
const datasourceRoute = _computed<Location>(() => ({
  name: 'sources.source.overview',
  params: { id: props.overviewData?.details?.datasourceId! ?? 'null' },
}));
const externalDescriptionsValue = _computed(() => {
  if (!props.overviewData) return null;
  return ('externalDescriptions' in props.overviewData.details!)
    ? props.overviewData.details!.externalDescriptions : null;
});

return { __sfc: true,props, routeToOverview, details, descriptionValue, datasourceName, ownersValue, lastRefresh, lineagePlatform, datasourceRoute, externalDescriptionsValue, _computed, AssetOverviewTransformation, SAvatars, fromNow, getProviderIconSrc }
}

})